import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TokenStorageService } from '@core/services/token-storage.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly tokenStorage = inject(TokenStorageService);
  private readonly router = inject(Router);

  logout(): void {
    this.tokenStorage.clearSession();
    void this.router.navigate(['/login']);
  }
}
